export type FilteredActivities = {
  activities: (ActivityEntity | undefined)[] | undefined;
  trainings: (TrainingEntity | undefined)[] | undefined;
};

export function filterActivities(
  activities: (ActivityEntity | undefined)[] | undefined,
  endpointActivities: (ProcessProcessEntity | undefined)[],
  trainings: (TrainingEntity | undefined)[] | undefined
): FilteredActivities[] {
  const matchingIds = endpointActivities.map(
    (reflection) => reflection?.process_id
  );

  const filteredActivities = activities?.filter((activity) =>
    matchingIds.includes(activity?.id as number)
  );

  const filteredTrainings = trainings?.filter((training) =>
    matchingIds.includes(training?.id as number)
  );

  // Order the filteredActivities and filteredTrainings based on the order of matchingIds
  const orderedActivities = filteredActivities?.sort(
    (a, b) =>
      matchingIds.indexOf((a?.id as number)!) -
      matchingIds.indexOf((b?.id as number)!)
  );

  const orderedTrainings = filteredTrainings?.sort(
    (a, b) =>
      matchingIds.indexOf((a?.id as number)!) -
      matchingIds.indexOf((b?.id as number)!)
  );

  return [{ activities: orderedActivities, trainings: orderedTrainings }];
}
